import { ChangeDetectionStrategy, Component } from '@angular/core';
import { VERSION_INFO } from '@env/version';
import { SharedModule } from '@shared/shared.module';


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'pek-version-info',
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class VersionInfoComponent {
  protected readonly erpVersion = VERSION_INFO.version;
  protected readonly erpName = VERSION_INFO.name;
  protected readonly buildDate = VERSION_INFO.buildDate;
}
